// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getTcsmSettings} from '../../shared/repositories';
import {readSpaClaims} from './get-spa-claims';

export const readTcsmSettings = (selectedDealers, userId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const tcsmSettings = await getTcsmSettings(userId);

            dispatch({
                tcsmSettings,
                type: actions.UPDATE_TCSM_WIP_TCSM_SETTINGS
            });

            dispatch({
                selectedSpaLevels: tcsmSettings.selectedSpaLevels,
                type: actions.UPDATE_TCSM_WIP_SELECTED_SPA_LEVELS
            });

            readSpaClaims(selectedDealers, tcsmSettings.selectedSpaLevels)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetTcsmSettingsFacet = selectedSpaLevels => ({
    selectedSpaLevels,
    type: actions.RESET_TCSM_WIP_TCSM_SETTINGS_FACET
});

export const toggleSpaLevelsListItems = allowedSpaLevels => ({
    allowedSpaLevels,
    type: actions.TOGGLE_TCSM_WIP_SPA_LEVELS_LIST
});

export const updateSelectedSpaLevelsList = (item, isSelected) => ({
    isSelected,
    item,
    type: actions.UPDATE_TCSM_WIP_SELECTED_SPA_LEVELS_LIST
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/tcsm-settings.js